"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureValidSalesForceToken = exports.refreshSalesForceAccessToken = exports.persistSalesForceTokens = exports.toAuthDomain = void 0;
const helpers_1 = require("@/app/shared/helpers");
const TOKEN_EXPIRY_SKEW_MS = 60000;
let refreshPromise = null;
const toAuthDomain = (env) => env === "PRODUCTION" /* ServerEnvironment.PRODUCTION */ ? 'login' : 'test';
exports.toAuthDomain = toAuthDomain;
const persistSalesForceTokens = (tokens, env) => {
    helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN, tokens.access_token);
    if (tokens.refresh_token) {
        helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_SALESFORCE_REFRESH_TOKEN, tokens.refresh_token);
    }
    if (tokens.instance_url) {
        helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_SALESFORCE_INSTANCE_URL, tokens.instance_url);
    }
    helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN_EXPIRATION, String(Date.now() + tokens.expires_in));
    helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_TYPE, "SALESFORCE" /* ServerType.SALESFORCE */);
    helpers_1.Storage.Local.set(helpers_1.Storage.Key.SERVER_ENVIRONMENT, env);
};
exports.persistSalesForceTokens = persistSalesForceTokens;
const refreshSalesForceAccessToken = async () => {
    if (refreshPromise)
        return refreshPromise;
    const env = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_ENVIRONMENT);
    const refreshToken = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_REFRESH_TOKEN) || '';
    refreshPromise = (async () => {
        try {
            const tokens = await helpers_1.Http.postJson((0, helpers_1.buildSumoAdminUrl)('/public/token/refresh'), {
                refresh_token: refreshToken,
                domain: (0, exports.toAuthDomain)(env),
            });
            (0, exports.persistSalesForceTokens)(tokens, env);
            return tokens;
        }
        finally {
            refreshPromise = null;
        }
    })();
    return refreshPromise;
};
exports.refreshSalesForceAccessToken = refreshSalesForceAccessToken;
const ensureValidSalesForceToken = async () => {
    const accessToken = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN) || '';
    if (!accessToken)
        return '';
    const expiration = helpers_1.Storage.Local.getNumber(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN_EXPIRATION) || 0;
    const refreshToken = helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_REFRESH_TOKEN) || '';
    const isExpired = expiration > 0 && Date.now() > expiration - TOKEN_EXPIRY_SKEW_MS;
    if (isExpired && refreshToken) {
        await (0, exports.refreshSalesForceAccessToken)();
    }
    return helpers_1.Storage.Local.get(helpers_1.Storage.Key.SERVER_SALESFORCE_ACCESS_TOKEN) || '';
};
exports.ensureValidSalesForceToken = ensureValidSalesForceToken;
